import '../../Pages/Client/Cvtheque/CvTheque.scss';

import { Add, InfoOutlined } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import { AppBar, Button, Dialog, FormControl, IconButton, Toolbar, Tooltip, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import useFormValidation from '../../hooks/useFormValidation';
import usePostRequest from '../../hooks/usePostRequest';
import useUtilities from '../../hooks/useUtilities';
import useWindowSize from '../../hooks/useWindowSize';
import { buttonStyles, buttonStylesGreen } from '../docsAdministrative/JsObjectStyles';
import RegimeModeTravail from '../shared/RegimeModeTravail';
import { IconTextField, TextFieldComponent, Transition } from '../shared/ReusableSmallComponents';
import SearchCity from '../shared/SearchCity';

function DialogCreatealerte({  open, onClose }) {
    DialogCreatealerte.propTypes = {
        open: PropTypes.any,
        onClose: PropTypes.func,
    };
    //! hooks rule : call a hook only inside a functionnal component, don't try to create a function to prevent DRY ..
    const { setShowErrors, setErrors } = useUtilities();
    const { postData } = usePostRequest();
    const [intitulePoste, setIntitulePoste] = useState('');
    const {device}=useWindowSize();
    const { i18n } = useTranslation();
    const [modeTravail, setModeTravail] = React.useState({
        type: '',
        nbJrsRemotePerWeek: '',
    });
    const [regimeTravail, setRegimeTravail] = React.useState({
        type: '',
        nbJrsPartielPerWeek: '',
    });
    const [localisation, setLocalisation] = useState();
    const [keywords, setKeywords] = useState('');
    const [isValid] = useFormValidation([
        { name: 'intitulePoste', value: intitulePoste },
    ]);

    const addAlert = async () => {
        try {
            postData({
                url: '/expert/addAlert', payload: {
                    intitulePoste,
                    localisation, keywords,
                    modeTravail, regimeTravail
                }
            });
            resetDataAndClose();
        } catch (error) {
            console.log(error.response?.status, error.response?.data.error);
        }
    };
    const scroll='paper';
    const resetDataAndClose = () => {
        setIntitulePoste('');
        setModeTravail({
            type: '',
            nbJrsRemotePerWeek: '',
        });
        setLocalisation();
        setRegimeTravail({
            type: '',
            nbJrsPartielPerWeek: '',
        });
        setKeywords('');
        onClose();
    };
    return (
        <Dialog
            fullScreen
            open={open}
            TransitionComponent={Transition}
            onClose={resetDataAndClose}
            scroll={scroll}
            PaperProps={{
                style: {
                    background: '#F5F6FA',
                },
            }}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
        >
            <AppBar>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={resetDataAndClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <form style={{display:'flex',background: '#F5F6FA',paddingTop: '150px',justifyContent:'center',width:'100%'}}>
                <div className='frame14Modified4ClasserCvTheque'>
                    <h4 className='titlesociete'>{i18n.t('Créer une alerte')}</h4>
                    <p>{i18n.t('Créez une alerte et recevez  par e-mail des notifications de vos recherches')}</p>

                    <FormControl style={{display:'flex',gap:'12px',alignSelf:'stretch'}}>
                        <div style={{display:'flex',flexDirection:'column',gap:'8px',width:'100%'}}>
                            <h6 className='nomPrenomProfile'>{i18n.t('Intitulé de poste')}</h6>

                            <IconTextField
                                //id="outlined-name"
                                //label="Nom"
                                placeholder={i18n.t('Rechercher un poste')}
                                style={{width:'100%', borderRadius:'8px',background:'white'}}
                                sx={{
                                    '& > :not(style)': { borderRadius:'8px' },
                                }}
                                iconEnd={<Add />}
                                //InputProps={{
                                //    endAdornment: (
                                //        <div className='iconStyleStartAdornment iconStyleEndAdornment'>
                                //            <InputAdornment position="end">
                                //                <Add />
                                //            </InputAdornment>
                                //        </div>
                                //    ),
                                //}}
                                name='intitulePoste'
                                value={intitulePoste}
                                onChange={(e) => setIntitulePoste(e.target.value)}
                                autoComplete='off'
                            />
                            <h6 className='nomPrenomProfile'>{i18n.t('Informations supplémentaires')}</h6>
                            <RegimeModeTravail
                                setModeTravail={setModeTravail}
                                setRegimeTravail={setRegimeTravail}
                                modeTravail={modeTravail}
                                regimeTravail={regimeTravail}
                            />
                            <div className='Frame101292323112'>
                                <p  className='IntitulePoste'>{i18n.t('Localisation')} </p>
                                <SearchCity
                                    width='100%'
                                    setCity={setLocalisation}
                                    city={localisation}
                                />
                            </div>
                            <div className='Frame101292323112'>
                                <p  className='IntitulePoste'>{i18n.t('Mots clés')} &nbsp; &nbsp;
                                    <Tooltip
                                        title={
                                            <Typography component="div">
                                                <p>{i18n.t('Opérateurs et syntaxes:')}</p>
                                                <ul>
                                                    <li>
                                                        {i18n.t('A ET B: La recherche des CV qui doivent inclure A et B')}
                                                    </li>
                                                    <li>{i18n.t('A OU B: La recherche des CV qui incluent A et B ou les 2')}</li>
                                                    <li>{i18n.t('“A B”: La recherche d&apos;un mot clé composé de deux mots (ex. “Spring Boot”)')}</li>
                                                    <li>{i18n.t('(A OU B) et (C OU D): Les () pour affiner la recherche')}</li>
                                                </ul>
                                                <p>{i18n.t('A savoir:')}</p>
                                                <ul>
                                                    <li>
                                                        {i18n.t('Les recherches sont insensibles à la casse (Maj/min)')}
                                                    </li>
                                                </ul>
                                            </Typography>
                                        }
                                    >
                                        <IconButton style={{padding:'0px',height:'30px',alignSelf:'center'}}>
                                            <InfoOutlined />
                                        </IconButton>
                                    </Tooltip>
                                </p>
                                <TextFieldComponent
                                    // id="margin-none"
                                    autoComplete="off"
                                    style={{width:'100%',borderRadius:'8px',background:'white'}}
                                    sx={{
                                        '& > :not(style)': {
                                            borderRadius: '8px',
                                        },
                                    }}
                                    // multiline
                                    value={keywords}
                                    // name='search'
                                    onChange={(newValue) => {
                                        setKeywords(newValue.target.value);
                                    }}
                                    // style={{ width: '75%' || '261.25px' }}
                                    // sx={{
                                    //     '& > :not(style)': { borderRadius: '8px' },
                                    // }}
                                    placeholder={i18n.t('Mots clés, exemple: (Angular ou “Node JS”) et React')}
                                />
                            </div>
                        </div>
                        <div style={{display:'flex',alignSelf:'stretch',justifyContent:'flex-end',flexDirection:device=='desktop'?'row':'column'}}>
                            <Button
                                variant='text'
                                style={{...buttonStyles(),
                                    ...{width:device=='desktop'?'118px':'100%'}
                                }}
                                onClick={resetDataAndClose}
                            >{i18n.t('Annuler')}</Button>
                            <Button
                                variant='contained'
                                style={{...buttonStylesGreen(false),...{width: device=='desktop'?'111px':'100%',}}}
                                type='submit'
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (isValid) {
                                        addAlert();
                                        resetDataAndClose();
                                        setShowErrors(false);
                                        setErrors({});
                                    }
                                    else if(!isValid){
                                        setShowErrors(true);
                                    }
                                }}
                            >
                                {i18n.t('Créer')}
                            </Button>
                        </div>
                    </FormControl>
                </div>
            </form>
        </Dialog>
    );
}

export default DialogCreatealerte;

// import '../../Pages/Client/AO/Alertes.scss';

// import { SearchOutlined } from '@mui/icons-material';
// import CloseIcon from '@mui/icons-material/Close';
// import { AppBar, Button, Dialog, IconButton, Toolbar } from '@mui/material';
// import PropTypes from 'prop-types';
// import React, { useState } from 'react';

// import {buttonStylesGreen } from '../docsAdministrative/JsObjectStyles';
// import RegimeModeTravail from '../shared/RegimeModeTravail';
// import { TextFieldComponent, Transition } from '../shared/ReusableSmallComponents';
// import SearchCity from '../shared/SearchCity';

// function DialogCreatealerte({open,onClose}) {

//     DialogCreatealerte.propTypes = {
//         open: PropTypes.any,
//         onClose: PropTypes.func,
//     };

//     function handleClick() {
//         setStatut(!statut);
//     }
//     const [modeTravail, setModeTravail] = React.useState({
//         type: '',
//         nbJrsRemotePerWeek: '',
//     });
//     const [regimeTravail, setRegimeTravail] = React.useState({
//         type: '',
//         nbJrsPartielPerWeek: '',
//     });
//     const [statut, setStatut] = useState(true);
//     const [localisation,setLocalisation]=useState('');

//     return (
//         <Dialog
//             onClose={onClose}
//             open={open}
//             fullScreen
//             TransitionComponent={Transition}
//             PaperProps={{
//                 style: {
//                     background: '#FFFFFF',
//                 },
//             }}
//             aria-labelledby="scroll-dialog-title"
//             aria-describedby="scroll-dialog-description"
//         >
//             <AppBar>
//                 <Toolbar>
//                     <IconButton
//                         edge="start"
//                         color="inherit"
//                         onClick={onClose}
//                         aria-label="close"
//                     >
//                         <CloseIcon />
//                     </IconButton>
//                 </Toolbar>
//             </AppBar>
//             <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center',alignItems:'center' ,minHeight:'900px',height:'100%', paddingBottom: '24px' }}>
//                 <div className='createalertediv'>
//                     <h4 className='titlesociete'>Créer une alerte</h4>
//                     <b className='creersoustxt'>Créez une alerte et recevez  par e-mail des notifications de vos recherches</b>
//                     <div className='rechercheposte'>
//                         <label className='recherchepostetxt'>Intitulé de poste</label>
//                         <TextFieldComponent
//                             required
//                             variant="outlined"
//                             placeholder=' Rechercher un poste'
//                             InputProps={{ startAdornment: <SearchOutlined /> }}
//                             //size="small"
//                             sx={{
//                                 '& > :not(style)': {borderRadius: '8px' },
//                             }}
//                             style={{ width: '600px', height: '48px', background: 'white',borderRadius:'8px' }}
//                         />

//                     </div>
//                     <div className='rechercheposte2'>
//                         <label className='recherchepostetxt'>Localisation</label>
//                         <SearchCity
//                             width='600px'
//                             setCity={setLocalisation}
//                             city={localisation}
//                             label='Ville'
//                             name='localisation'
//                         />
//                     </div>
//                     <div className='rechercheposte2'>
//                         <label className='recherchepostetxt'>Mots clés</label>
//                         <TextFieldComponent
//                             required
//                             variant="outlined"
//                             placeholder=' Ajouter des compétences par exemple'
//                             sx={{
//                                 '& > :not(style)': {borderRadius: '8px' },
//                             }}
//                             style={{ width: '600px', height: '48px', background: 'white',borderRadius: '8px' }}
//                         />
//                     </div>
//                     <div className='rechercheposte2'>
//                         <h6 className='nomPrenomProfile'>Informations supplémentaires</h6>
//                         <RegimeModeTravail
//                             setModeTravail={setModeTravail}
//                             setRegimeTravail={setRegimeTravail}
//                             modeTravail={modeTravail}
//                             regimeTravail={regimeTravail}
//                         />
//                     </div>
//                     <div className='btns'>
//                         <Button
//                             style={{...buttonStylesGreen(false)
//                             }}
//                             onClick={handleClick}
//                         >Créer
//                         </Button>
//                     </div>
//                 </div>
//             </div>
//         </Dialog>
//     );
// }

// export default DialogCreatealerte;